import {useEffect, useRef} from 'react';
// Based on: https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state

export function usePreviousValue<T> (value: T): T {
    const reference = useRef<T>(value);
    useEffect(() => {
        reference.current = value;
    });

    return reference.current;
}
